import { useRef } from 'react';
import { useQueries } from '@tanstack/react-query';
import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
const NO_VALUES = [];
const FIVE_MINUTES = 5 * 60 * 1000;
function sameQueryStates(a, b) {
    return a.length === b.length && a.every((state, index)=>state.key === b[index].key && state.data === b[index].data && state.loading === b[index].loading && state.loaded === b[index].loaded);
}
function toValuesMap(states) {
    return Object.fromEntries(states.map((param)=>{
        let { key, data, loading, loaded } = param;
        var _ref;
        return [
            key,
            {
                values: (_ref = data === null || data === void 0 ? void 0 : data.values) !== null && _ref !== void 0 ? _ref : NO_VALUES,
                truncated: !!(data === null || data === void 0 ? void 0 : data.truncated),
                loading,
                loaded
            }
        ];
    }));
}
export function useClientReferenceFieldValues(keys) {
    const { api } = useStoreActions();
    const queries = useQueries({
        queries: keys.map((key)=>({
                queryKey: [
                    QueryKeys.ClientReferenceFieldValues,
                    key
                ],
                queryFn: ()=>api.client.getReferenceFieldValues(key),
                staleTime: FIVE_MINUTES,
                refetchOnMount: true,
                retry: false,
                networkMode: 'always'
            }))
    });
    const states = keys.map((key, index)=>({
            key,
            data: queries[index].data,
            loading: queries[index].isInitialLoading,
            loaded: queries[index].isSuccess
        }));
    const memoised = useRef();
    if (!memoised.current || !sameQueryStates(memoised.current.states, states)) {
        memoised.current = {
            states,
            values: toValuesMap(states)
        };
    }
    return memoised.current.values;
}
